import SubjectsRouter, {SubjectsPage} from './subjects';

export default SubjectsRouter;
export {
    SubjectsPage
};
